// extracted by mini-css-extract-plugin
export default {"title":"styles_title__Dxyvp","mainTitle":"styles_mainTitle__9-bey","descr":"styles_descr__jpUvb","longSubtitle":"styles_longSubtitle__WipQo"};